export default class WalletClient {

  constructor({ethereum, _log, 
    chainId, readContract, prepareWriteContract, writeContract, getNetwork, switchNetwork, waitForTransaction, signMessage, sendTransaction
    }) {
    this.ethereum = ethereum
    this.chainId = parseInt(chainId)
    this.readContract = readContract
    this.prepareWriteContract = prepareWriteContract
    this.writeContract = writeContract
    this.getNetwork = getNetwork
    this.switchNetwork = switchNetwork
    this.waitForTransaction = waitForTransaction
    this.signMessage = signMessage
    this.sendTransaction = sendTransaction
    this.log = _log
  }

  help() {
    console.log('')
  }

  async #readyTransaction(functionName, dropDetail, contractAbi, numberToMint, args) {
    const price = (BigInt(dropDetail.wei_price) * BigInt(numberToMint)).toString()

    return await this.prepareWriteContract({
      address: dropDetail.contract_address,
      abi: contractAbi,
      functionName,
      args,
      value: price,
      chainId: this.chainId
    })
  }
  
  #addIfExists(array, value){
    if(value) {
      array.push(value)
    }
    return array
  }

  async allowedPurchase(dropDetail, contractAbi, proof, numberToMint, tokenHashes, isBlindMint) {
    const method = dropDetail.status === 'art_pass_sale' ? 'artPassMint' : 'allowlistMint'
    const contractArgs = [proof, numberToMint, dropDetail.edition_number]
    this.#addIfExists(contractArgs, tokenHashes)
    this.#addIfExists(contractArgs, isBlindMint)

    try {
      const preparedTransaction = await this.#readyTransaction(method, dropDetail, contractAbi, numberToMint, contractArgs)
      const { hash } =  await this.writeContract(preparedTransaction)
      return { error: null, hash }
    } catch (e) {
      this.log(e)
      return { error: this.#getErrorMessage(e), hash: null }
    }
  }

  async openPurchase(dropDetail, contractAbi, numberToMint, tokenHashes, isBlindMint) {
    const contractArgs = [numberToMint, dropDetail.edition_number]
    this.#addIfExists(contractArgs, tokenHashes)
    this.#addIfExists(contractArgs, isBlindMint)

    try {
      const preparedTransaction = await this.#readyTransaction('mint', dropDetail, contractAbi, numberToMint, contractArgs)
      const { hash } = await this.writeContract(preparedTransaction)
      return { error: null, hash }
    }
    catch(e) {
      this.log(e)
      return { error: this.#getErrorMessage(e), hash: null }
    }
  }

  async burnClaims(tokensToBurn, basePayment, shippingPayment, contractAddress) {
    const functionName = 'burnClaims'
    const contractAbi = [{'inputs':[{'internalType':'uint256[]','name':'tokenIds','type':'uint256[]'}],'name':'burnClaims','outputs':[],'stateMutability':'payable','type':'function'}]
    const args = [tokensToBurn]
    const price = (BigInt(basePayment) * BigInt(tokensToBurn.length)) + BigInt(shippingPayment)

    const preparedTransaction = await this.prepareWriteContract({
      address: contractAddress,
      abi: contractAbi,
      functionName,
      args,
      value: price,
      chainId: this.chainId
    })

    try {
      const { hash } =  await this.writeContract(preparedTransaction)
      return { error: null, hash }
    } catch (e) {
      this.log(e)
      return { error: this.#getErrorMessage(e), hash: null }
    }
  }

  async sendPayment(count, basePayment, shippingPayment, escrowWalletAddress) {
    const price = (BigInt(basePayment) * BigInt(count)) + BigInt(shippingPayment)

    try {
      const { hash } =  await this.sendTransaction({
        chainId: this.chainId,
        to: escrowWalletAddress,
        value: price,
      })
      return { error: null, hash }
    } catch (e) {
      this.log(e)
      return { error: this.#getErrorMessage(e), hash: null }
    }
  }

  #getErrorMessage(e) {
    const message = e.message
    console.log(e)
    console.log(e.message)

    if(message?.includes('Connector not found')) {
      return 'Please connect to Metamask'
    } if(message?.includes('The total cost (gas * gas fee + value) of executing this transaction exceeds the balance of the account')) {
      return 'Insufficient funds'
    } if(message?.includes('Incorrect amount of ether sent')) {
      return 'Incorrect amount of ether sent'
    } if(message?.includes('Exceeds Art Pass holder mint limit')) {
      return 'Exceeded mint limit'
    } if(message?.includes('Exceeds per address mint limit')) {
      return 'Exceeded mint limit'
    } if(message?.includes('Mint exceeds collection size')) {
      return 'Sold out'
    } if(message?.includes('User rejected the request')){
      return 'Request rejected'
    } if(message?.includes('The requested account and/or method has not been authorized by the user')){
      return 'Account not authorized by user'
    } if(message?.includes('The provider is disconnected from all chains')){
      return 'Disconnected from Mainnet'
    } if(message?.includes('Transaction rejected')){
      return 'Transaction rejected.'
    } if(message?.includes('Method not supported')){
      return 'Method not supported.'
    } if(message?.includes('Request limit exceeded')){
      return 'Request limit exceeded.'
    } if(message?.includes('Chain mismatch')){
      return 'Please connect to the correct chain.'
    }


    return 'Error occurred'
  }

  async getFinalTransactionStatus(hash) {
    const tx = await this.waitForTransaction({
      hash,
      chainId: this.chainId
    })
    const status = tx.status === 'success'
    let tokenId
    try {
      tokenId = status ? parseInt(tx.logs[0].topics[3], 16)
      : -1
    }
    catch(e) {
      //we could be watching a transaction that doesn't have a token interaction
    }

    return {status, tokenId}
  }

  async signedMessage(message) {
    try {
      return await this.signMessage({ message })
    }
    catch(e) {
      this.log(e)
      return null
    }
  }

  async formatWei(wei, afterDecimalLength = 4) {
    const gwei = Number(wei.substr(0, wei.length - 9))
    const ether = (gwei / Math.pow(10,9)).toString()

    if(ether.indexOf('.') != -1) {
      const split = ether.split('.')
      const beforeDecimal = split[0] == '' ? '0' : split[0]
      let afterDecimal = split[1] == '' ? '0' : split[1]
      if(afterDecimal.length > afterDecimalLength){
        afterDecimal = afterDecimal.substring(0, afterDecimalLength)
      }
      return `${beforeDecimal}.${afterDecimal} ETH`
    }
    else {
      return ether + ' ETH'
    }
  }

  isCorrectChain() {
    const { chain } = this.getNetwork()
    if(!chain) {
      return true
    }
    return this.chainId == chain.id
  }

  async requestSwitchChain() {
    try {
      await this.switchNetwork({
        chainId: this.chainId,
      })
      return true
    }
    catch(e) {
      this.log(e)
      return false
    }
  }
}
